import styled from 'styled-components';

export default styled.h2`
  font-size: 1.5em;
  font-weight: bold;
  margin: 1.5rem 0 1rem 0;
`;
